import * as React from 'react';
import * as Styles from './styled';

interface SettingsContainerProps {
  header?: React.ReactNode;
  children: React.ReactNode;
}

const SettingsContainer = ({ header, children }: SettingsContainerProps) => {
  return (
    <>
      {header && (
        <Styles.Header>
          {typeof header === 'string' ? <Styles.HeaderTitle>{header}</Styles.HeaderTitle> : header}
        </Styles.Header>
      )}
      {children}
    </>
  );
};

export default React.memo(SettingsContainer);
